import React from "react";
import PropTypes from "prop-types";
import { compose } from "redux";
import { withStyles } from "@mui/styles";
import { pick } from "lodash";
import Panel from "common/components/Panel";
import { transformApiError } from "common/api/errors";
import client from "common/admin/client";
import ContactTopicForm from "./Form";
import { withUrlResource } from "common/utils";
import { useTranslation } from "react-i18next";

const handleSubmit = (buildingId) => async (values, form) => {
  const body = pick(values, "name", "contact_email");

  const { setSubmitting, setErrors, setStatus, resetForm } = form;

  try {
    await client.post(`buildings/${buildingId}/contact_topics`, { body });
    resetForm();
    setStatus({ success: true });
  } catch (error) {
    const apiError = transformApiError(error);
    if (apiError.empty()) {
      setErrors({ http: error.message });
    } else {
      setErrors(apiError.object());
    }
  }
  setSubmitting(false);
};

const CreateContactTopic = ({ classes, urlResource }) => {
  const { t } = useTranslation();
  return (
    <Panel title={t("contact_topics_create.title")}>
      <ContactTopicForm
        handleSubmit={handleSubmit(urlResource.id)}
        initialValues={{
          name: "",
          contact_email: "",
        }}
      />
    </Panel>
  );
};

const styles = (theme) => ({
  button: {
    marginTop: theme.spacing(2),
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 180,
  },
});

CreateContactTopic.propTypes = {
  classes: PropTypes.object.isRequired,
  urlResource: PropTypes.shape({
    id: PropTypes.number.isRequired,
  }).isRequired,
};

const enhanced = compose(withStyles(styles), withUrlResource);

export default enhanced(CreateContactTopic);
